"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EU_PROVIDERS = exports.NON_EU_PROVIDERS = exports.EU_COUNTRIES = exports.SOVEREIGNTY_WEIGHTS = exports.RISK_VALUES = exports.RISK_WEIGHTS = void 0;
// Risk weights for overall score calculation
exports.RISK_WEIGHTS = {
    gdpr: 0.4,
    nis2: 0.35,
    dora: 0.25,
};
// Risk level numeric values
exports.RISK_VALUES = {
    LOW: 1,
    MEDIUM: 2,
    HIGH: 3,
};
// Sovereignty score weights
exports.SOVEREIGNTY_WEIGHTS = {
    nonEU: 60,
    highRisk: 40,
};
// EU countries (ISO 2-letter codes)
exports.EU_COUNTRIES = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
    'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
    'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
];
// Non-EU providers (for jurisdiction classification)
exports.NON_EU_PROVIDERS = {
    'AWS': 'US',
    'Amazon Web Services': 'US',
    'Azure': 'US',
    'Microsoft Azure': 'US',
    'Google Cloud': 'US',
    'GCP': 'US',
    'Salesforce': 'US',
    'HubSpot': 'US',
    'Slack': 'US',
    'Zoom': 'US',
    'OpenAI': 'US',
    'Anthropic': 'US',
};
// EU providers
exports.EU_PROVIDERS = {
    'OVHcloud': 'EU',
    'Scaleway': 'EU',
    'Hetzner': 'EU',
    'Deutsche Telekom': 'EU',
};
